var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fn-ui-layout-navigation"},[_vm._t("header"),_c('div',{staticClass:"fn-ui-layout-navigation__body"},[_vm._t("default")],2)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }